import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { getCampaignStepsEditorNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-editor-nextjs-url ';
import { getCampaignStepsListNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-list-nextjs-url';
import { useContactCampaigns } from 'modules/contacts/contact-page/hooks/use-contact-campaigns';
import { ContactCampaignsInterface } from 'modules/contacts/contact-page/types/contact-campaigns-interface';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { ContactId } from '../../types/contact-interface';
interface ContactCampaignsProps {
  contactId: ContactId;
}
const ContactCampaigns = t0 => {
  const $ = _c(50);
  const {
    contactId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination(true);
  let t1;
  if ($[0] !== contactId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      contactId,
      limit,
      pagination
    };
    $[0] = contactId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    contactCampaigns
  } = useContactCampaigns(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("global.name");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "campaign",
      widthPercent: 35,
      header: t2,
      onRender: _temp
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.contact_page.step_name");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      key: "lastCampaignStep",
      widthPercent: 35,
      header: t4,
      onRender: _temp2
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("dashboard.contact_page.last_email_sent_on");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== user?.dateFormat || $[15] !== user?.timeFormat || $[16] !== user?.timezone) {
    t7 = campaign_1 => campaign_1.lastStepScheduledDate && <Tooltip wrapperClassName="w-full" mode="hover" label={dateTimeFormat(campaign_1.lastStepScheduledDate, {
      timeFormat: user?.timeFormat,
      dateFormat: user?.dateFormat,
      timeZone: user?.timezone
    })}><span className="w-full truncate">{dateFormat(campaign_1.lastStepScheduledDate, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></Tooltip>;
    $[14] = user?.dateFormat;
    $[15] = user?.timeFormat;
    $[16] = user?.timezone;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t || $[19] !== user?.dateFormat || $[20] !== user?.timeFormat || $[21] !== user?.timezone) {
    t8 = campaign_2 => campaign_2.lastStepScheduledDate && <div className="flex items-center gap-3"><span className="text-text-primary font-bold">{t("global.date")}</span><span>{dateTimeFormat(campaign_2.lastStepScheduledDate, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></div>;
    $[18] = t;
    $[19] = user?.dateFormat;
    $[20] = user?.timeFormat;
    $[21] = user?.timezone;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = {
      key: "getLastStepScheduledDate",
      widthPercent: 30,
      header: t6,
      onRender: t7,
      onRenderSmall: t8
    };
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t3 || $[28] !== t5 || $[29] !== t9) {
    t10 = [t3, t5, t9];
    $[27] = t3;
    $[28] = t5;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const columns = t10;
  let t11;
  if ($[31] !== t) {
    t11 = t("dashboard.contact_page.email_campaigns");
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11) {
    t12 = <h2 className="h-[42px] text-[17px] font-bold">{t11}</h2>;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== limit || $[36] !== setLimit) {
    t13 = {
      limit,
      setLimit
    };
    $[35] = limit;
    $[36] = setLimit;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== pagination || $[39] !== setPagination) {
    t14 = {
      pagination,
      setPagination
    };
    $[38] = pagination;
    $[39] = setPagination;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== columns || $[42] !== contactCampaigns || $[43] !== t13 || $[44] !== t14) {
    t15 = <Table limiter={t13} paginator={t14} data={contactCampaigns} columns={columns} />;
    $[41] = columns;
    $[42] = contactCampaigns;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== contactCampaigns || $[47] !== t12 || $[48] !== t15) {
    t16 = <ListingLayout counter={false} data={contactCampaigns} type="compact" title={t12}>{t15}</ListingLayout>;
    $[46] = contactCampaigns;
    $[47] = t12;
    $[48] = t15;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
};
export default ContactCampaigns;
function _temp(campaign) {
  return <div className="truncate"><LinkWithoutPrefetch className="primary-link w-full" href={getCampaignStepsListNextjsUrl(campaign.campaign.id)}><Tooltip mode="overflow" label={campaign.campaign.name}>{campaign.campaign.name}</Tooltip></LinkWithoutPrefetch></div>;
}
function _temp2(campaign_0) {
  return campaign_0.lastCampaignStep ? <div className="truncate"><LinkWithoutPrefetch className="primary-link w-full" href={getCampaignStepsEditorNextjsUrl({
      campaignId: campaign_0.campaign.id,
      campaignStepId: campaign_0.lastCampaignStep.id
    })}><Tooltip mode="overflow" label={campaign_0.lastCampaignStep.mailing.currentEmail.subject}>{campaign_0.lastCampaignStep.mailing.currentEmail.subject}</Tooltip></LinkWithoutPrefetch></div> : <></>;
}